export const POSTS_LIST = 'POSTS_LIST';
export const USER_WALL_POSTS = 'USER_WALL_POSTS';
export const CREATE = 'CREATE';
export const DELETE = 'DELETE';
export const UPDATESHARED = 'UPDATESHARED';
export const UPDATE = 'UPDATE';
export const DELETESHARED = 'DELETESHARED';
export const POSTS_LIST_NEXT = 'CREATE';
export const CC_UPDATES_LIST = 'CC_UPDATES_LIST';
export const UPDATEMEDIA = 'UPDATEMEDIA';
export const DELETEMEDIA = 'DELETEMEDIA';
export const CREATEMEDIA = 'CREATEMEDIA';
export const MEMBER_WALL_POSTS = 'MEMBER_WALL_POSTS';
